import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "container mt-5",
  style: {"max-width":"350px"}
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 my-5 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 my-5"
}
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 1,
  class: "fa-solid fa-2x fa-magnifying-glass text-muted"
}
const _hoisted_7 = { class: "display-7 my-3 h3 mb-1 text-primary" }
const _hoisted_8 = { class: "text-muted mb-3" }


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    title: {},
    msg: {},
    totalItemsRegistered: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.totalItemsRegistered === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "noItemsRegistered")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.$slots.icon)
                ? _renderSlot(_ctx.$slots, "icon", { key: 0 })
                : (_openBlock(), _createElementBlock("i", _hoisted_6)),
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.title || "Nenhum resultado no momento"), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.msg || `Não foram encontrados resultados.`), 1),
              _renderSlot(_ctx.$slots, "button")
            ])
          ]))
    ])
  ]))
}
}

})